import React from 'react'
import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import { getCurrencyString } from 'src/helpers/formatAmount'

export type GiftCardTileProps = {
  currency?: string
  amount: string
  brand?: { title: string; brandImage?: string }
  giftCardPreviewUrl?: string
}

export const GiftCardTile = (props: GiftCardTileProps) => {
  const { currency, amount, brand, giftCardPreviewUrl } = props

  const font = 'Montserrat, sans-serif'

  const imageBaseStyles = {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }

  const handleTruncateTitle = (title?: string) => {
    const MAX_TITLE_LENGTH = 21
    if (!title) return

    return title.length >= MAX_TITLE_LENGTH
      ? title.substring(0, MAX_TITLE_LENGTH) + '..'
      : title
  }

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        padding: '8px 12px 8px 10px',
        borderRadius: '16px',
        backgroundColor: '#fffc',
        backdropFilter: 'blur(6px)',
        boxShadow: '0px 4px 32px 0px rgba(0, 0, 0, 0.04)',
        minWidth: '318px',
      }}
    >
      <Flex justifyContent="space-between" width="100%" alignItems="center">
        <Flex justifyContent="center" flexDirection="column" width={'100%'}>
          <Text
            type="footnote"
            content="Gift Card:"
            style={{
              fontFamily: font,
              fontWeight: 700,
              fontSize: '10px',
              color: '#6B7280',
            }}
          />
          <Flex width={'100%'} alignContent={'center'}>
            <div
              style={{
                ...imageBaseStyles,
                backgroundImage: `url(${giftCardPreviewUrl})`,
                aspectRatio: '13/8',
                width: '52px',
                height: '32px',
                borderRadius: '4px',
              }}
            />
            <Flex
              justifyContent={'space-between'}
              alignItems={'center'}
              width={'100%'}
              height={'32px'}
            >
              <Text
                type="footnote"
                content={`${handleTruncateTitle(brand?.title) ?? 'Loading... '}`}
                style={{
                  fontFamily: font,
                  fontWeight: 600,
                  fontSize: '16px',
                  color: '#404040',
                  paddingLeft: '8px',
                }}
              />
              <Flex height={'100%'} alignItems={'center'}>
                <Flex height={'100%'} justifyContent={'start'}>
                  <Text
                    type="footnote"
                    content={`${getCurrencyString(currency)}`}
                    style={{
                      fontFamily: font,
                      fontWeight: 400,
                      fontSize: '10px',
                      color: '#404040',
                    }}
                    inset={{ top: 'x_25' }}
                  />
                </Flex>
                <Text
                  type="footnote"
                  content={`$${amount.split('.')[0]}`}
                  style={{
                    fontFamily: font,
                    fontWeight: 600,
                    fontSize: '16px',
                    color: '#404040',
                  }}
                  alignment={'center'}
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </div>
  )
}
